var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 105,
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.809 24.02H80.9396C76.4112 24.02 72.7432 27.688 72.7432 32.2114V66.0488C72.7432 70.5721 76.4112 74.2402 80.9396 74.2402H127.809C132.332 74.2402 136 70.5721 136 66.0488V32.2114C136 27.688 132.332 24.02 127.809 24.02Z",
    fill: "#7A5FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2681 32.6342C78.2681 30.8127 79.7373 29.3435 81.5587 29.3435H127.165C128.986 29.3435 130.455 30.8127 130.455 32.6342V61.2236C130.455 63.045 128.986 64.5142 127.165 64.5142H81.5587C79.7373 64.5142 78.2681 63.045 78.2681 61.2236V32.6342Z",
    fill: "#6FF0FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.356 48.046C97.3927 48.046 104.9 40.3779 104.9 30.5361C104.9 40.388 111.079 48.046 122.188 48.046C111.079 48.046 104.9 54.1141 104.9 63.332C104.9 54.0185 97.5839 48.046 88.356 48.046Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.412 72.3484H96.3413V77.5007H112.412V72.3484Z",
    fill: "#7A5FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.216 76.3689H92.5272C90.2227 76.3689 88.356 78.2356 88.356 80.5351C88.356 82.8345 90.2227 84.7012 92.5272 84.7012H116.216C118.52 84.7012 120.387 82.8345 120.387 80.5351C120.387 78.2356 118.52 76.3689 116.216 76.3689Z",
    fill: "#7A5FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAi);
export default __webpack_public_path__ + "static/media/card_ai.e16cbc71437dddfb481f63787b43cc3c.svg";
export { ForwardRef as ReactComponent };